module.exports = __webpack_public_path__ + "media/img/about/person/jon-15a879ecc0d3d40b8a444e03015f28fd.webp";